import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@marineform/environment';
import {
  ApiResponse,
  ModuleRecordCountDto,
} from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';
import { MANAGE_API_PATHS } from '../data';

@Injectable({
  providedIn: 'root',
})
export class SummaryService {
  #http = inject(HttpClient);

  getCounts(): Observable<ApiResponse<ModuleRecordCountDto[]>> {
    return this.#http.get<ApiResponse<ModuleRecordCountDto[]>>(
      `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.SUMMARY}`,
    );
  }
}
